// extracted by mini-css-extract-plugin
module.exports = {"container":"Flights_container__LXfmj","markdown":"Flights_markdown___aefM"};